<!-- splash screen -->
<div #splashScreen class="splash-screen">
  <img [src]="constants.applicationLogoUrl" alt="Logo" />
</div>
